import axios from 'axios';

// Thin wrapper around /api/lessonhomeworks - same shape convention as
// workspace/lessonTopicsApi.js, kept local to this feature.

export function getLessonHomeworks(lessonId) {
   return axios.get('/api/lessonhomeworks?lesson=' + lessonId, { withCredentials: true });
}

// One request for a whole lesson-list view instead of one per row - see
// workspace/lessonTopicsApi.js's getLessonTopicsBulk twin.
export function getLessonHomeworksBulk(lessonIds) {
   if (!lessonIds || lessonIds.length === 0) {
      return Promise.resolve({ data: [] });
   }
   return axios.get('/api/lessonhomeworks?lessonIds=' + lessonIds.join(','), { withCredentials: true });
}

export function createLessonHomework(payload) {
   return axios.post('/api/lessonhomeworks', JSON.stringify(payload), {
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
   });
}

export function updateLessonHomework(id, payload) {
   return axios.put('/api/lessonhomeworks/' + id, JSON.stringify(payload), {
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
   });
}

export function deleteLessonHomework(id) {
   return axios.delete('/api/lessonhomeworks/' + id, { withCredentials: true });
}
